import type { ElementNodeDto } from './schemas/element.schema';

// The three parts of a page, as Shopify's editor files a theme: Header, Template and Footer. A root says
// which part it belongs to through the landmark its section draws as — `header`, `footer`, or anything
// else for the page's own content. The builder files sections by it, the storefront wraps the template
// part in the page's <main>, and a page a theme does not ship borrows the home page's header and footer.

/** The parts of a page, in the order a visitor reads them. */
export const PAGE_ZONES = ['header', 'template', 'footer'] as const;

/** One part of a page. */
export type PageZone = (typeof PAGE_ZONES)[number];

// Names the part of the page one root belongs to, from the landmark tag its section carries.
export function zoneOf(node: ElementNodeDto): PageZone {
  const tag = node.props.tag;
  return tag === 'header' || tag === 'footer' ? tag : 'template';
}
